enum SolAvatarStatusEnum {
  Online = 'online',
  Busy = 'busy',
  Away = 'away',
  Offline = 'offline',
  None = 'none',
}

type SolAvatarStatus = `${SolAvatarStatusEnum}`;

export {SolAvatarStatusEnum, SolAvatarStatus};
